<template>
  <div class="row">


    <!-- form -->
    <div class="col-12" style="margin-top: 50px;  padding-right: 0 !important;padding-left: 0 !important;">
      <div class="form" style="width: 500px;border: solid 1px rgba(245, 245, 245, 0.26);">
        <div class="row" style="padding: 20px">


          <div class="">
            <div class="row">

              <div class="main__title">
                <h2>آپلودر</h2>
              </div>

              <div class="col-12">
                <div style="margin-top: 30px">
                  <div style="margin-bottom: 10px;">عنوان</div>
                  <input class="form__input " v-model="title"/>
                </div>
              </div>

              <div class="col-12">
                <div style="margin-top: 30px;">
                  <div style="margin-bottom: 10px;">انتخاب سرور</div>
                  <select class="form__input " v-model="server">
                    <option value="" disabled selected>انتخاب کنید</option>
                    <option value="dl1">سرور dl1</option>
                    <option value="dl3">سرور dl3</option>
                  </select>
                </div>
              </div>
              <div class="col-12">
                <div style="margin-top: 30px">
                  <div style="margin-bottom: 10px;">لینک</div>
                  <input class="form__input " v-model="url"/>
                </div>
              </div>

              <div class="">
                <div style="margin-top: 50px">
<!--                  <ImageSelector label="فایل"-->
<!--                                 v-model:previewImage="file_preview"-->
<!--                                 @imagefile="(n) => file = n"-->
<!--                  />-->

                  <ButtonSelector
                      label="انتخاب فایل"
                      v-model:previewImage="file_preview"
                      @imagefile="(n) => file = n"
                  />


                </div>
              </div>

            </div>
          </div>


          <div class="col-12">
            <div class="row">

              <div class="col-12 upload-ink">
                {{ download_link }}
              </div>

              <div class="col-12">
                <p v-if="upload_percent!=''" style="color: white">
                  {{ upload_percent }}%
                </p>

                <div class="col-6">
                  <button type="button" class="form__btn" style="margin-top: 30px" @click="insert_data">ارسال فایل</button>

                </div>
                <div class="col-6">
                  <button type="button" class="form__btn" style="margin-top: 30px" @click="insert_data_url">ارسال لینک</button>

                </div>




              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end form -->
  </div>
</template>

<script>
import axios from "axios";
// import {bus} from '../main';
import Datatable from "@/views/customTable/Datatable";
import ImageSelector from "@/views/CustomComponent/ImageSelector";
import ButtonSelector from "@/views/CustomComponent/ButtonSelector.vue";

export default {
  name: 'Country',
  data() {
    return {
      items: [],
      fields: [
        {key: 'row', label: 'ردیف'},
        {key: 'name', label: 'نام'},
        {key: 'image', label: 'تصویر'},
        {key: 'operation', label: 'عملیات'}
      ],
      status_form: 0,
      name: '',
      upload_percent: '',
      bio: '',
      file: null,
      file_preview: '',
      cover_file: null,
      cover_file_preview: '',
      download_link: '',
      server: '',
      title: '',
      url: '',
    }
  },
  components: {
    Datatable,
    ImageSelector,
    ButtonSelector

  },
  mounted() {
    // this.get_data();
  },
  methods: {
    edit_item(item) {
      this.name = item.name;
      this.bio = item.summary;
      this.file_preview = item.image;
      this.status_form = item.id;
      this.file = null
    },
    insert_data() {

      var self = this;

      var formData = new FormData();
      var url = 'upload_video'
      formData.append('title', this.title);
      formData.append('server', this.server);
      formData.append('file', this.file);
      const config = {
        onUploadProgress: progressEvent => self.upload_progress(progressEvent)
      }
      this.axios.post(url, formData, config).then(function (response) {
        self.download_link = response.data
        self.name = ''
        self.bio = ''
        self.title = ''
        self.file = null
        self.status_form = 0;

      }).catch(function (error) {
        console.log(error);
      });


    },
    insert_data_url() {

      var self = this;

      var formData = new FormData();
      var url = 'upload_video_url'
      formData.append('title', this.title);
      formData.append('server', this.server);
      formData.append('url', this.url);
      const config = {
        onUploadProgress: progressEvent => self.upload_progress(progressEvent)
      }
      this.axios.post(url, formData, config).then(function (response) {
        self.download_link = response.data
        self.name = ''
        self.bio = ''
        self.title = ''
        self.file = null
        self.status_form = 0;

      }).catch(function (error) {
        console.log(error);
      });


    },
    upload_progress(progressEvent) {
      this.upload_percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      document.getElementsByClassName("loading-text")[0].innerHTML = "در حال آپلود " + this.upload_percent + "%"
      if (this.upload_percent > 98) {
        document.getElementsByClassName("loading-text")[0].innerHTML = "لطفا صبر کنید"
      }
    }
  }
}
</script>
<style>

.form__input{
  width: 100%;
}

.upload-ink{
  margin-top: 50px !important;
}
</style>
